import Vue from 'vue'
import store from '@/store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

axios.interceptors.request.use((request) => {
  // Skip progress for /user and /ai/ requests (AI module handles its own loading state)
  if (!request.url.match(/user$/) && !request.url.match(/\/ai\//)) {
    store.commit('setProgress', true);
  }
  return request;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // Clear progress on error to prevent stuck loading indicator
  store.commit('setProgress', false);
  return Promise.reject(error);
});